import type { ClusterListItem } from '@b4b/shared';
import ClusterCard from '../ClusterCard.js';
import FeedFooter, { type Pager } from './FeedFooter.js';
import FilterChips from './FilterChips.js';
import { useCardKeyboard } from '../../lib/useCardKeyboard.js';
import type { FeedParams } from '../../lib/feedUrl.js';

// Feedly "magazine" style: image left, title + excerpt right, one card per row.
// Read state changes only on open or via the card actions (no mark-on-scroll).
export default function ListFeed({
  items,
  params,
  pager,
  fetchingFirstArticles,
}: {
  items: ClusterListItem[];
  params: FeedParams;
  pager: Pager;
  fetchingFirstArticles: boolean;
}) {
  const focusIndex = useCardKeyboard(items);
  return (
    <div data-layout="list" className="px-4 pb-4 pt-20">
      <FilterChips params={params} />
      <div className="space-y-3">
        {items.map((item, index) => (
          <ClusterCard key={item.id} item={item} focused={index === focusIndex} />
        ))}
      </div>
      <FeedFooter itemCount={items.length} params={params} pager={pager} fetchingFirstArticles={fetchingFirstArticles} />
    </div>
  );
}
